import styled from "@emotion/styled";

interface IBlogWrapper {
  isDarkTheme: boolean;
}
export const BlogWrapper = styled("div")<IBlogWrapper>`
  width: 100%;
  height: 100%;
  background-color: ${({ isDarkTheme }: any) =>
    isDarkTheme ? "var(--primary-theme-color)" : "var(--white-color)"};

  .blogs-container {
    position: relative;
    top: 6rem;
    height: calc(100% - 6rem);
    width: 120rem;
    margin: auto;
    display: flex;
    flex-direction: column;
    row-gap: 3rem;
  }

  .header {
    box-sizing: border-box;
    width: 100%;
    height: 10rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .header span {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 1rem;
  }

  .header-text,
  .content-text {
    font-family: "Comfortaa-Bold";
    font-size: 2.5rem;
    font-weight: bold;
    color: ${({ isDarkTheme }: any) =>
      isDarkTheme ? "var(--white-color)" : "var(--senary-theme-color)"};
  }

  .previous-button {
    display: none;
  }

  .ic-more {
    font-size: 5rem;
    font-weight: 700;
    object-fit: contain;
    cursor: pointer;
    color: ${({ isDarkTheme }: any) =>
      isDarkTheme ? "var(--white-color)" : "var(--senary-theme-color)"};
  }

  .blog-contents {
    width: 100%;
    height: calc(100% - 10rem);
    display: flex;
    flex-direction: column;
    row-gap: 5rem;
    overflow: scroll;
  }

  .blogs-title {
    font-family: "Comfortaa-Bold";
    font-size: 3.8rem;
    font-weight: bold;
    color: ${({ isDarkTheme }: any) =>
      isDarkTheme ? "var(--white-color)" : "var(--senary-theme-color)"};
  }

  .content-menu {
    width: 100%;
    display: flex;
    align-items: center;
    column-gap: 1.5rem;
  }

  .content-menu-icon {
    cursor: pointer;
    font-size: 4rem;
    color: ${({ isDarkTheme }: any) =>
      isDarkTheme ? "var(--white-color)" : "var(--senary-theme-color)"};
  }

  .blogs-image {
    width: 100%;
    object-fit: cover;
    height: 45rem;
  }

  .blogs-description {
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 5rem;
  }

  .description-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 2rem;
  }

  .description-header {
    font-family: "Comfortaa-Bold";
    font-size: 7.4rem;
    font-weight: bold;
    color: ${({ isDarkTheme }: any) =>
      isDarkTheme ? "var(--white-color)" : "var(--senary-theme-color)"};
  }

  .description-text {
    font-family: "Comfortaa-Regular";
    font-size: 2.2rem;
    line-height: 1.5;
    text-align: justify;
    color: ${({ isDarkTheme }: any) => (isDarkTheme ? "#d2d2da" : "#101012")};
  }

  @media screen and (max-width: 840px) {
    .blogs-container {
      top: 0rem;
      height: calc(100% - 0rem);
      width: 100%;
      background-color: none;
      row-gap: 2rem;
    }

    .header {
      box-sizing: border-box;
      padding: 0rem 1.5rem;
      background-color: var(--denary-theme-color);
    }

    .header-text,
    .ic-more {
      color: var(--white-color);
    }

    .previous-button {
      display: block;
      color: var(--secondary-lite-grey-color);
      font-size: 3rem;
    }

    .blogs-title {
      font-size: 2rem;
    }

    .blogs-title,
    .content-menu {
      width: 90%;
      margin: 0rem auto;
    }

    .content-menu-icon {
      cursor: pointer;
      font-size: 3rem;
    }

    .blog-contents {
      row-gap: 3.5rem;
    }

    .content-text {
      font-size: 2rem;
    }

    .blogs-description {
      width: 90%;
      margin: 0rem auto;
      row-gap: 3rem;
    }

    .commingSoon {
      justify-content: center;
      align-items: center;
    }

    .description-header {
      font-size: 2rem;
    }

    .description-text {
      font-size: 1.6rem;
    }

    .blogs-image {
      height: 40rem;
    }
  }

  @media (min-width: 840px) and (max-width: 1024px) {
    .blogs-container {
      width: 95%;
    }
  }
`;

export const MenuItemStyles = styled("div")<any>`
  font-family: "Comfortaa-Light";
  color: var(--nonary-grey-color);
  font-size: 2.5rem;
  text-align: center;
  padding: 15px;
  border-bottom: ${({ isShowBorder }) =>
    isShowBorder ? "none" : "1px solid #313139"};
`;
